import React, { useEffect, useState } from 'react';
import DialogBox from '../../global/DialogBox';
import SnpButton from '../../global/SnpButton';
import '../BillingModule.css';
import DismissButton from '../../global/DismissButton';
import {
    INITIAL_CUSTOMER_DATA,
    INITIAL_ITEM_DIALOG } from '../resto-billing/RestBillConstants';
import { Typography } from '../../ui';
import DialogCustomerInput from './DialogCustomerInput';
import BuildTextViewUi from './BuildTextViewUi';
import uiUtilInstance from '../../../utilities/uiUtil';
import DialogDateChange from './DialogDateChange';
import {
  BillStatus,
  isEmpty
} from '../../../constants/constant';
import DialogHotelContent from './DialogHotelContent';
import DialogPartialPay from './DialogPartialPay';

const RestoDialogBase = ({ custDialog, setCustDialog, customerData,
    setCustomerData, custCopy,
    setCustCopy, printCustomerBill,
    itemDialog, setItemDialog, callItemOperation
    , createdAt, setCreatedAt, dateChange, setDateChange, backDateAllowed,
    hotelRoomDialog, setHotelRoomDialog,
    externalBillDetails, setExternalBillDetails, fireSnackBarMsg, 
    setCustAvailable,billStatus, removeRoomApi, kot,
    partialPayDialog,
    setPartialPayDialog,
    partialPay,
    duesAmt,
    currDues,
    partialPayList,
    setPartialPay,
    setCurrDues,
    updatePartialPayMoney}) => {

    const [vCustomerData, setVcustomerData] = useState(INITIAL_CUSTOMER_DATA);

    useEffect(() => {
        if (custDialog) {
            setVcustomerData(customerData);
        }
    }, [custDialog]);

    const handleDialogClose = () => {
        setVcustomerData(INITIAL_CUSTOMER_DATA);
        setCustDialog(false);
    }

    const hasCustomerData = (customerData) => {
        return Object.entries(customerData).some(([key, value]) => {
            if (key === "custMob") return false; // skip custMob
            if (typeof value === "boolean") return false; // skip booleans
            return value !== ""; // check if non-empty
        });
    };

    const addCustomerInput = () => {
        setCustomerData(prev => ({
            ...prev, ...vCustomerData,
        }));
        setCustDialog(false);
        setCustAvailable(hasCustomerData(vCustomerData));
    }

    const customerInputDialogActions = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onClick={addCustomerInput}>
                    Add
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={handleDialogClose}>
                    Cancel
                </DismissButton>
            </>
        )
    };

    const custCopyUi = () => {
        return (
            <Typography variant="subtitle4" component="div" style={{ color: "#2f1160" }} >Do You Want to Print Customer Copy</Typography>
        )
    };

    const custCopyAction = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onClick={printCustomerBill}>
                    Yes
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={() => setCustCopy(false)}>
                    No
                </DismissButton>
            </>
        )
    };
    const custCopyFunc = () => {
        return < DialogBox
            showDialog={custCopy}
            title="Alert!"
            onClose={() => setCustCopy(false)}
            dialogContent={custCopyUi()}
            dialogActions={custCopyAction()}
        />
    };

    const itemDialogActions = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onClick={callItemOperation}>
                    {itemDialog.action === 1  ? "Delete" :"Submit" }
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={() => setItemDialog(INITIAL_ITEM_DIALOG)}>
                    Dismiss
                </DismissButton>
            </>
        )
    };

    const dialogDateChangeAction = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onClick={() => setDateChange(false)}>
                    Change
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={() => {
                    setDateChange(false);
                    setCreatedAt(uiUtilInstance.todayFormattedDate);
                }}>
                    Dismiss
                </DismissButton>
            </>
        )
    };

    const dialogHotelRoomAction = () => {
        return (
            <>
                {
                    (!externalBillDetails.saved && !isEmpty(externalBillDetails.hotelBillNo)
                        && externalBillDetails.roomBooked) && <SnpButton variant="contained" color="primary" onClick={() => {
                            setHotelRoomDialog(false);
                            setCustAvailable(true);
                            setCustomerData(prev => ({
                                ...prev,
                                custMob: externalBillDetails.mobNo, custName: externalBillDetails.custName,
                                custEmail: externalBillDetails.emailId, address: externalBillDetails.address,
                            }))
                        }}>
                        Set
                    </SnpButton>
                }
                {
                    (!externalBillDetails.saved && !isEmpty(externalBillDetails.hotelBillNo)) && <DismissButton variant="contained" color="primary" onClick={() => {
                        setExternalBillDetails(prev => ({
                            ...prev,
                            hotelBillId: "",
                            hotelBillNo: "",
                            roomBooked: false,
                            saved: false,
                            mobNo: "",
                            emailId: "",
                            address: "",
                        }));
                        setCustomerData(prev => ({
                            ...prev,
                            custMob: "", custName: "",
                            custEmail: "", address: "",
                        }))
                        setCustAvailable(!isEmpty(customerData.custId));
                        setHotelRoomDialog(false);
                    }}>
                        Clear
                    </DismissButton>
                }
                {
                    (externalBillDetails.saved && !isEmpty(externalBillDetails.hotelBillNo)
                        && !externalBillDetails.payLaterSignal && billStatus !== BillStatus.PAID) && <SnpButton variant="contained" color="primary" onClick={() => {
                            removeRoomApi();
                            setHotelRoomDialog(false);
                        }}>
                        Remove Room
                    </SnpButton>
                }
                <DismissButton variant="contained" color="primary" onClick={() => {
                    if (!externalBillDetails.saved) {
                        setExternalBillDetails(prev => ({
                            ...prev,
                            hotelBillId: "",
                            hotelBillNo: "",
                            roomBooked: false,
                            saved: false,
                            mobNo: "",
                            emailId: "",
                            address: "",
                        }));
                    }
                    setHotelRoomDialog(false);
                }}>
                    Dismiss
                </DismissButton>
            </>
        )
    };

    const partialPayAction = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onClick={updatePartialPayMoney}>
                    Pay
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={() => setPartialPayDialog(false)}>
                    Dismiss
                </DismissButton>
            </>
        )
    };

    const getProdName = () => {
        if (itemDialog.action === 0) {
            return `Item: ${itemDialog.itemName}`;
        } else if (itemDialog.action === 1) {
            return `Do you want to delete ${itemDialog.itemName}`;
        } else if (itemDialog.action === 2) {
            return "Enter Otp to Generate Bill";
        } 
        return "";
    }

    const getLabel = () => {
        if (itemDialog.action === 0) {
            return "Enter Notes";
        } else if (itemDialog.action === 1) {
            return "Enter Reason For Delete";
        } else if (itemDialog.action ===  2) {
            return "Enter Otp";
        }
        return `Enter Valid KOT No(1 to ${kot})`;
    }

    return (
        <>
            <DialogBox
                showDialog={custDialog}
                title="Enter Customer Details"
                onClose={() => setCustDialog(false)}
                dialogContent={<DialogCustomerInput
                    vCustomerData={vCustomerData}
                    setVcustomerData={setVcustomerData} />}
                dialogActions={customerInputDialogActions()}
            />
            {custCopyFunc()}
            <DialogBox
                showDialog={itemDialog.action !== -1}
                title=""
                onClose={() => setItemDialog(INITIAL_ITEM_DIALOG)}
                dialogContent={<BuildTextViewUi
                    prodName={getProdName()}
                    label={getLabel()}
                    dialogMsg={itemDialog.dialogMsg}
                    minRows={itemDialog.action >= 2 ? 1 : 2}
                    setDialogMsg={(msg) => setItemDialog(prev => ({
                        ...prev, dialogMsg: msg,
                    }))} />}
                dialogActions={itemDialogActions()}
            />
            <DialogBox
                showDialog={dateChange}
                title=""
                // onClose={customerInputDialogClose}
                dialogContent={<DialogDateChange
                    createdAt={createdAt}
                    setCreatedAt={setCreatedAt}
                    backDateAllowed={backDateAllowed} />
                }
                dialogActions={dialogDateChangeAction()} />
            <DialogBox
                showDialog={hotelRoomDialog}
                title="Room Details"
                // onClose={customerInputDialogClose}
                dialogContent={<DialogHotelContent
                    externalBillDetails={externalBillDetails}
                    setExternalBillDetails={setExternalBillDetails}
                    fireSnackBarMsg={fireSnackBarMsg}
                />
                }
                dialogActions={dialogHotelRoomAction()}
            />
            <DialogBox
                showDialog={partialPayDialog}
                title="Partial Bill Update"
                onClose={()=> setPartialPayDialog(false)}
                dialogContent={<DialogPartialPay
                    partialPay={partialPay}
                    duesAmt={duesAmt}
                    billStatus={billStatus}
                    currDues={currDues}
                    partialPayList={partialPayList}
                    setPartialPay={setPartialPay}
                    setCurrDues={setCurrDues}
                    fireSnackBarMsg={fireSnackBarMsg}
                />
                }
                dialogActions={partialPayAction()}
            />
        </>
    )
};

export default RestoDialogBase;